/**
 * A project counts as shared once its share image is saved, which happens
 * when the share dialog is first opened.
 *
 * @param {boolean} isShareable
 * @param {Object|null} [image] - saved share image from useProjectImage
 * @returns {boolean}
 */
export default function hasBeenShared(isShareable, image) {
  return isShareable && !!image;
}
